import type { ITheme } from '@fluentui/react';

export const getStyles = (_: unknown, { palette = {} as ITheme['palette'] }: { palette?: ITheme['palette'] }) => ({
  subTitleContainer: {
    fontWeight: 400,
    fontSize: '16px',
    lineHeight: '21px',
    marginBottom: 32,
    color: palette.neutralPrimary,
    textAlign: 'center',
  },
});
